import { request } from "./utils";


export function getQuery(data) {
    return request({
        url: "/uapws/rest/flight/query",
        method: "post",
        data,
    });
}


export function insterElectronice(data) {
    return request({
        url: "/uapws/rest/flight/inster",
        method: "post",
        data,
    });
}